import "core-js/modules/es.string.trim.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import papaparse from "papaparse";
import loadWithXhr from "../Core/loadWithXhr";

// We'd like to use `FeatureDetection.supportsWebWorkers()` here, but
// PapaParse doesn't get along with our webpack configuration. It ends up
// trying to load the entire bundle into a web worker. This is inefficient
// to begin with, but also breaks because we use `require` and `window` in
// places and these are not defined in web workers.
const useWorker = false;
export default class Csv {
  /**
   * Parses a CSV from a string.
   * @param csv The string to parse as a CSV.
   * @param columnMajor True if the returned array is an array of columns; False if the returned array is an array of rows.
   * @returns A promise that resolves to the CSV data.
   */
  static parseString(csv) {
    let columnMajor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    let filterOutComments = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    return new Promise((resolve, reject) => {
      papaparse.parse(csv, _objectSpread(_objectSpread({}, getParseOptions(columnMajor, filterOutComments, resolve, reject)), options));
    });
  }

  /**
   * Parses a CSV from a file.
   * @param csv The file to parse as a CSV.
   * @param columnMajor True if the returned array is an array of columns; False if the returned array is an array of rows.
   * @returns A promise that resolves to the CSV data.
   */
  static parseFile(file) {
    let columnMajor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    let filterOutComments = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    return new Promise((resolve, reject) => {
      papaparse.parse(file, _objectSpread(_objectSpread({}, getParseOptions(columnMajor, filterOutComments, resolve, reject)), options));
    });
  }

  /**
   * Parses a CSV from a URL.
   * @param csv The URL to parse as a CSV.
   * @param columnMajor True if the returned array is an array of columns; False if the returned array is an array of rows.
   * @returns A promise that resolves to the CSV data.
   */
  static parseUrl(url) {
    let columnMajor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    let filterOutComments = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    return loadWithXhr({
      url
    }).then(csv => {
      if (typeof csv === "string") {
        return Csv.parseString(csv, columnMajor, filterOutComments, options);
      } else {
        throw "Request failed";
      }
    });
    // There is currently a bug when using papaparse to fetch CSV URLs
    // See: https://github.com/mholt/PapaParse/pull/832
    // return new Promise<string[][]>((resolve, reject) => {
    //   papaparse.parse(url, {
    //     ...getParseOptions(columnMajor, resolve, reject),
    //     download: true,
    //   });
    // });
  }
}
function getParseOptions(columnMajor, filterOutComments, resolve, reject) {
  return columnMajor ? getParseOptionsColumnMajor(filterOutComments, resolve, reject) : getParseOptionsRowMajor(filterOutComments, resolve, reject);
}
function getParseOptionsRowMajor(filterOutComments, resolve, reject) {
  const result = [];
  let parser = null;
  return {
    comments: filterOutComments,
    skipEmptyLines: true,
    worker: useWorker,
    chunk: function (results, p) {
      parser = p;
      const data = results.data;
      for (let i = 0; i < data.length; ++i) {
        result.push(data[i]);
      }
    },
    complete: function () {
      resolve(result);
    },
    error: function (e) {
      // If we did manage to get some data lets use what we've got
      // Perhaps there was an error because there was no Content-Length header
      if (result.length > 0) parser.abort();else reject(e);
    }
  };
}
function getParseOptionsColumnMajor(filterOutComments, resolve, reject) {
  const result = [];
  let parser = null;
  return {
    comments: filterOutComments,
    skipEmptyLines: true,
    worker: useWorker,
    chunk: function (results, p) {
      parser = p;
      const data = results.data;
      for (let i = 0; i < data.length; ++i) {
        const row = data[i];
        if (i === 0) cleanColumnNames(row);
        for (let j = 0; j < row.length; ++j) {
          let destColumn = result[j];
          if (destColumn === undefined) {
            destColumn = [];
            result.push(destColumn);
          }
          destColumn.push(row[j]);
        }
      }
    },
    complete: function () {
      resolve(result);
    },
    error: function (e) {
      // If we did manage to get some data lets use what we've got
      // Perhaps there was an error because there was no Content-Length header
      if (result.length > 0) parser.abort();else reject(e);
    }
  };
}
function cleanColumnNames(columnNames) {
  for (let i = 0; i < columnNames.length; ++i) {
    if (typeof columnNames[i] === "string") {
      columnNames[i] = columnNames[i].trim();
    }
  }
}